import { combineReducers } from 'redux'

import profile from './occupations/profile'

import * as profileActions from '../actions/occupationProfile'
import {
  OCCUPATION_COMPARISON,
  OCCUPATION_LOADED,
  VIDEO_DETAIL_LOADED,
  VIDEOS_LOADED
} from '../actions/occupationProfile'
import * as h2Api from '../h2Api'
import { ALL_OCCUPATION_LISTING } from '../actions/occupations/occupations'

const initialState = {
  selectedOccupations: [],
  error: null
}
const occupationComparisonReducer = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.OCCUPATION_COMPARISON_SET_ERROR:
      return {
        ...state,
        error: action.error
      }

    case profileActions.REMOVE_OCCUPATION_FOR_COMPARISON:
      return {
        ...state,
        selectedOccupations: state.selectedOccupations.filter(i => i !== action.onetSoc)
      }

    case profileActions.CLEAR_COMPARISON:
      return {
        ...state,
        selectedOccupations: []
      }

    case profileActions.SELECT_OCCUPATION_FOR_COMPARISON:
      if (state.selectedOccupations.indexOf(action.onetSoc) >= 0) {
        return state
      }

      return {
        ...state,
        selectedOccupations: [...state.selectedOccupations, action.onetSoc]
      }

    case profileActions.SET_OCCUPATIONS_FOR_COMPARISON:
      return {
        ...state,
        selectedOccupations: action.onetSocs
      }

    default:
      return state
  }
}
const occupations = combineReducers({
  profile,
  allOccupationsRequest: h2Api.restReducer(ALL_OCCUPATION_LISTING),
  profileRequest: h2Api.restReducer(OCCUPATION_LOADED),
  videoListingRequest: h2Api.restReducer(VIDEOS_LOADED),
  videoDetailRequest: h2Api.restReducer(VIDEO_DETAIL_LOADED),
  comparison: occupationComparisonReducer,
  comparisonResponse: h2Api.restReducer(OCCUPATION_COMPARISON)
})

export default occupations
